import type { ReportingConfig } from '@centric-os/types';
import { cloneDeep, isNil } from 'lodash-es';
import { DateTime } from 'luxon';

export default () => {
  const convertTimeToDate = (timeStr: string): Date => {
    // Parse the time string
    const [hours, minutes] = timeStr.split(':').map(Number);

    // Set the parsed time on today's date with seconds and milliseconds set to zero
    const referenceDate = DateTime.now().set({
      hour: hours,
      minute: minutes,
      second: 0,
      millisecond: 0,
    });

    return referenceDate.toJSDate();
  };

  const convertDateToTimeString = (date: Date): string => {
    return DateTime.fromJSDate(date).toFormat('HH:mm');
  };

  const mapReportConfigResponse = (response: ReportingConfig): ReportingConfig => {
    if (isNil(response)) {
      return {
        location_group_id: '',
        is_default: true,
        day_time: null,
        day_parts: [],
      };
    }

    // Convert day_time if present
    if (response.day_time) {
      // @ts-expect-error FIXME: Argument of type 'string | Date' is not assignable to parameter of type 'stri...
      response.day_time = convertTimeToDate(response.day_time);
    }

    // Convert day_parts start and end times if present
    if (response.day_parts && Array.isArray(response.day_parts)) {
      response.day_parts = response.day_parts.map((dayPart) => {
        const mappedDayPart = { ...dayPart };

        if (dayPart.start) {
          // @ts-expect-error FIXME: Argument of type 'string | Date' is not assignable to parameter of type 'stri...
          mappedDayPart.start = convertTimeToDate(dayPart.start);
        }
        if (dayPart.end) {
          // @ts-expect-error FIXME: Argument of type 'string | Date' is not assignable to parameter of type 'stri...
          mappedDayPart.end = convertTimeToDate(dayPart.end);
        }

        return mappedDayPart;
      });
    }

    return response;
  };

  const mapReportConfigPayload = (config: ReportingConfig): ReportingConfig => {
    // Create a deep copy of the config object
    const mappedConfig = cloneDeep(config);

    // Convert day_time from Date to UTC time string if present
    if (mappedConfig.day_time instanceof Date) {
      mappedConfig.day_time = convertDateToTimeString(mappedConfig.day_time);
    }

    // Convert day_parts start and end times from Date to UTC time string if present
    if (Array.isArray(mappedConfig.day_parts)) {
      mappedConfig.day_parts = mappedConfig.day_parts.map((dayPart) => {
        const mappedDayPart = { ...dayPart };

        if (mappedDayPart.start instanceof Date) {
          mappedDayPart.start = convertDateToTimeString(mappedDayPart.start);
        }
        if (mappedDayPart.end instanceof Date) {
          mappedDayPart.end = convertDateToTimeString(mappedDayPart.end);
        }

        return mappedDayPart;
      });
    }

    return mappedConfig;
  };

  return {
    mapReportConfigResponse,
    convertTimeToDate,
    convertDateToTimeString,
    mapReportConfigPayload,
  };
};
